import React from 'react';
import Icon from '../../../components/AppIcon';

const UserStatsCards = ({ stats }) => {
  const cards = [
    {
      title: 'Total Users',
      value: stats?.totalUsers,
      icon: 'Users',
      color: 'bg-accent/10 text-accent',
      change: `+${stats?.newUsersThisMonth} this month`
    },
    {
      title: 'Active Students',
      value: stats?.activeStudents,
      icon: 'GraduationCap',
      color: 'bg-success/10 text-success',
      change: `${stats?.studentEngagementRate}% engagement`
    },
    {
      title: 'Administrators',
      value: stats?.totalAdmins,
      icon: 'Shield',
      color: 'bg-secondary/10 text-secondary',
      change: `${stats?.adminCount} active`
    },
    {
      title: 'Inactive Users',
      value: stats?.inactiveUsers,
      icon: 'UserX',
      color: 'bg-error/10 text-error',
      change: `${stats?.inactivePercentage}% of total`
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
      {cards?.map((card, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-6 hover:shadow-lg transition-shadow duration-150"
        >
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 rounded-lg ${card?.color} flex items-center justify-center`}>
              <Icon name={card?.icon} size={24} />
            </div>
          </div>
          <h3 className="text-sm font-medium text-muted-foreground mb-1">{card?.title}</h3>
          <p className="text-3xl font-bold text-card-foreground mb-2">{card?.value}</p>
          <p className="text-sm text-muted-foreground">{card?.change}</p>
        </div>
      ))}
    </div>
  );
};

export default UserStatsCards;